import { render } from "./TagEditorModal.vue?vue&type=template&id=24631669&scoped=true&ts=true"
import script from "./TagEditorModal.vue?vue&type=script&lang=ts"
export * from "./TagEditorModal.vue?vue&type=script&lang=ts"

import "./TagEditorModal.vue?vue&type=style&index=0&id=24631669&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24631669"]])

export default __exports__